module.exports = __webpack_public_path__ + "static/31-b12d615e65ada2edd543585be067211b.jpg";